import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Box,
} from "@chakra-ui/react";
import {Col,Form,Row} from "react-bootstrap";
import axios from "axios";
import { fetchAsyncAddVendor } from "redux/vendorSlice";
import { useDispatch } from "react-redux";
import { useToasts } from "react-toast-notifications";
import { fetchAsyncDeleteVendorBank } from "redux/vendorSlice";
import { fetchAsyncUpdateVendor } from "redux/vendorSlice";
import { FaPlusCircle } from "react-icons/fa";
import { InputGroup, Tab, Tabs } from "react-bootstrap";
import { CiMail } from "react-icons/ci";
import { BsTelephone } from "react-icons/bs";
import { MdOutlinePhoneAndroid } from "react-icons/md";
import VendorCustomSelect from "./VendorCustomSelect";
import {
  findStateByGstCode,
  GstTreatment,
  indiaStateOptions,
  salutation,
} from "./customFieldData";
import SpinnerLoader from "components/Spinner/SpinnerLoader";
import { ACCOUNT_NUMBER_REGEX, EMAIL_REGEX, GST_REGEX, IFSC_REGEX, LANDLINE_REGEX, MAX_GST_LENGTH, MAX_IFSC_LENGTH, MAX_PAN_LENGTH, PAN_REGEX, PHONE_REGEX } from "../regexPatterns";
import commonJson from "components/jsonData/common.json";
import orgJson from "components/jsonData/orgnization.json";
import ConfirmationDialog from "components/sweetAlert.js/ConfirmationDialog";
import {
  GetCountries,
  GetState,
  GetCity,
} from "react-country-state-city";
import CustomPopover from "components/customPopover/customPopover";
import { fetchAsyncCheckGstIsUnique } from "redux/vendorSlice";
import BillAndShipAddressForm from "../component/Reusable/billAndShipAddress";
import BankForm from "../component/Reusable/bankForm";
import RadioField from "../component/radioField";
import CheckboxField from "../component/checkboxField";
import InputFormControl from "../component/inputFormControl";
import AmountInputField from "../component/amountField";

const VendorsAddNew = ({
  openModal,
  closeModal,
  isEdit = false,
  editData,
}) => {
  const finalRef = useRef(null);
  const [gstFields, setGstFields] = useState([{
    gstNo:"",
    pos:""
  }]);

  const [isVendor, setIsVendor] = useState(false);
  const [isConsultant, setIsConsultant] = useState(false);
  const [customerType, setCustomerType] = useState("");
  const [taxPreference, setTaxPreference] = useState("");
  const [isLoading, setIsLoading] = useState(false)
  const [formData, setFormData] = useState({
    companyName: "",
    salutation: "",
    contactPerson: "",
    email: "",
    phone: "",
    ledline: "",
    gstTreatment: "",
    gstNo: "",
    panNo: "",
    placeOfSupply: "",
    openingBal: "",
    bankDetails: [],
  });

  const [address, setAddress] = useState({
    billingAddress: {},
    shippingAddress: {},
  });
  const [activeTab, setActiveTab] = useState('')

  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();
  const { addToast } = useToasts();

  const validate = () => {
    const newErrors = {};

    if (!formData.companyName)
      newErrors.companyName = orgJson.required.comName;
    if (!formData.gstTreatment){
      newErrors.gstTreatment = orgJson.required.gstTreat;
    }

    if (!taxPreference) {
      newErrors.taxPreference = orgJson.required.taxPref;
    }
    if(formData?.gstTreatment && !['Unregistered Business','Consumer'].includes(formData?.gstTreatment?.value)){
      gstFields.forEach((field, index) => {
        if (formData.gstTreatment && !['Unregistered Business', 'Consumer'].includes(formData.gstTreatment?.value)) {
          if (!field?.gstNo) {
            newErrors[`gstFields.${index}.gstNo`] = "GST Number is required";
          } else if (!GST_REGEX.test(field?.gstNo)) {
            newErrors[`gstFields.${index}.gstNo`] = "GST Number format is invalid.";
          }
        }
      });
    }

    if (!formData.contactPerson)
      newErrors.contactPerson = orgJson.required.contactPer;
    if (formData.email && !EMAIL_REGEX.test(formData.email)) {
      newErrors.email = orgJson.error.email;
    }
    if (formData.ledline && !LANDLINE_REGEX.test(formData.ledline)) {
      newErrors.ledline = orgJson.error.invalidPhone;
    }
    if (formData.phone && !PHONE_REGEX.test(formData.phone)) {
      newErrors.phone = orgJson.error.phone;
    }
    if (formData.gstNo && !GST_REGEX.test(formData.gstNo)) {
      newErrors.gstNo = orgJson.error.email;
    }
    if (formData?.panNo && !PAN_REGEX.test(formData.panNo)) {
      newErrors.panNo = orgJson.error.pan;
    }

    // Validate bank details
    formData.bankDetails.forEach((bankDetail, index) => {
      if (!bankDetail.acNo) {
        newErrors[`bankDetails.${index}.acNo`] = orgJson.required.accNumber;
        if(activeTab && activeTab !== 'bank'){
          addToast("Please Check Bank details!", { appearance: "error" });
        }
      } else if (!ACCOUNT_NUMBER_REGEX.test(bankDetail.acNo)) {
        newErrors[`bankDetails.${index}.acNo`] = orgJson.error.accNumber
        if(activeTab && activeTab !== 'bank'){
          addToast("Please Check Bank details!", { appearance: "error" });
        }
      }
      if (!bankDetail.ifc) {
        newErrors[`bankDetails.${index}.ifc`] = orgJson.required.ifsc;
        if(activeTab && activeTab !== 'bank'){
          addToast("Please Check Bank details!", { appearance: "error" });
        }
      } else if (!IFSC_REGEX.test(bankDetail.ifc)) {
        newErrors[`bankDetails.${index}.ifc`] = orgJson.error.ifsc;
        if(activeTab && activeTab !== 'bank'){
          addToast("Please Check Bank details!", { appearance: "error" });
        }
      }
     
    });

    if (address?.billingAddress) {
      const { phone, email } = address.billingAddress;
      if (phone && !PHONE_REGEX.test(phone)) {
        newErrors.billPhone = orgJson.error.phone;
      }
      if (email && !EMAIL_REGEX.test(email)) {
        newErrors.billEmail = orgJson.error.email;
      }
    }

    if (address?.shippingAddress) {
      const { phone, email } = address.shippingAddress;
      if (phone && !PHONE_REGEX.test(phone)) {
        newErrors.shippPhone = orgJson.error.phone;
      }
      if (email && !EMAIL_REGEX.test(email)) {
        newErrors.shippEmail = orgJson.error.email;
      }
    }
    setErrors(newErrors);

    if(activeTab && activeTab !== 'otherDetails' && (newErrors.gstTreatment || newErrors.taxPreference || newErrors.gstNo)){
      addToast("Please Check Other details!", { appearance: "error" });
    }
    return Object.keys(newErrors).length === 0;
  };

  const toCamelCase = (value) => {
    return value
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    let formattedValue = value;

    if (name === "panNo" || name === "gstNo") {
      formattedValue = value.toUpperCase();
      if (name === "panNo" && formattedValue.length > MAX_PAN_LENGTH) {
        return;
      }

    } else if (name === "email") {
      formattedValue = value.toLowerCase();
    } else if(!name.startsWith("bankDetails.")) {
      formattedValue = toCamelCase(value);
    }

    if (name === "phone") {
      if (!formattedValue || PHONE_REGEX.test(formattedValue)) {
        setErrors((prev) => ({ ...prev, phone: "" }));
      } else {
        setErrors((prev) => ({
          ...prev,
          phone: orgJson.error.phone,
        }));
      }
    }
    if (name === "ledline") {
      if (!formattedValue || LANDLINE_REGEX.test(formattedValue)) {
        setErrors((prev) => ({ ...prev, ledline: "" }));
      } else {
        setErrors((prev) => ({ ...prev, ledline: orgJson.error.invalidPhone }));
      }
    }
    if (name === "email") {
      if (!formattedValue || EMAIL_REGEX.test(formattedValue)) {
        setErrors((prev) => ({ ...prev, email: "" }));
      } else {
        setErrors((prev) => ({ ...prev, email: orgJson.error.email }));
      }
    }
    
    if (name === "panNo") {
      if (!formattedValue || PAN_REGEX.test(formattedValue)) {
        setErrors((prev) => ({ ...prev, panNo: "" }));
      } else {
        setErrors((prev) => ({
          ...prev,
          panNo: orgJson.error.pan,
        }));
      }
    }

    if (name.startsWith("bankDetails.")) {
      const bankIndex = name.split(".")[1];
      const fieldName = name.split(".")[2];

      if (fieldName === "ifc") {
        formattedValue = value.toUpperCase();
        if (fieldName === "ifc" && formattedValue.length > MAX_IFSC_LENGTH) {
          return;
        }
      }
      if (fieldName === "acNo" || fieldName === "ifc") {
        setErrors((prev) => ({
          ...prev,
          [`bankDetails.${bankIndex}.${fieldName}`]: "",
        }));
      }
      setFormData((prev) => ({
        ...prev,
        bankDetails: prev.bankDetails.map((bankDetail, index) => {
          if (index === parseInt(bankIndex)) {
            if (fieldName.startsWith("bAd.")) {
              const addressFieldName = fieldName.split(".")[2];
              return {
                ...bankDetail,
                bAd: {
                  ...bankDetail.bAd,
                  [addressFieldName]: formattedValue,
                },
              };
            } else {
              return {
                ...bankDetail,
                [fieldName]: formattedValue,
              };
            }
          }
          return bankDetail;
        }),
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: formattedValue,
      }));
    }
  };

  const handleAddressChange = (e, type) => {
    const { name, value } = e.target;
    if (type === "billing") {
      setAddress((prev) => ({
        ...prev,
        billingAddress: {
          ...prev.billingAddress,
          [name]: value,
        },
      }));
    } else if (type === "shipping") {
      setAddress((prev) => ({
        ...prev,
        shippingAddress: {
          ...prev.shippingAddress,
          [name]: value,
        },
      }));
    }
  };

  const copyShippingAddress = (addressData) => {
    setAddress((prev) => ({
      ...prev,
      shippingAddress: prev?.billingAddress,
    }));
  };
  const fetchBranchDetails = async (index) => {
    const { ifc } = formData.bankDetails[index];
    const codeToFetch = ifc;
    if (!codeToFetch) return;

    try {
      const response = await axios.get(
        `https://ifsc.razorpay.com/${codeToFetch}`
      );
      const { BANK, BRANCH, CITY, STATE, SWIFT } = response.data;

      setFormData((prev) => ({
        ...prev,
        bankDetails: prev.bankDetails.map((bankDetail, i) => {
          if (i === index) {
            return {
              ...bankDetail,
              bnk: BANK,
              bch: BRANCH,
              swt: SWIFT,
              bAd: {
                ct: CITY,
                st: STATE,
              },
            };
          }
          return bankDetail;
        }),
      }));
    } catch (error) {
      addToast("Could not fetch branch details. Please check the IFSC or MICR code.", { appearance: "error" });
    }
  };

  const handleBlur = (index) => {
    if (IFSC_REGEX.test(formData.bankDetails[index].ifc)) {
      fetchBranchDetails(index);
    } else {
      setFormData((prev) => ({
        ...prev,
        bankDetails: prev.bankDetails.map((bankDetail, i) => {
          if (i === index) {
            return {
              ...bankDetail,
              bnk: "",
              bch: "",
              swt: "",
              bAd: {
                ct: "",
                st: "",
              },
            };
          }
          return bankDetail;
        }),
      }));
    }
  };

  const handleAddVendor = (data) => {
    setIsLoading(true)
    dispatch(fetchAsyncAddVendor(data))
      .then((res) => {
        if (res?.payload) {
          addToast(orgJson.success.createdVendor, { appearance: "success" });
          closeModal();
        } else {
          addToast(res?.error?.message, { appearance: "error" });
        }
      })
      .catch((error) => {
        addToast(orgJson.error.generic, { appearance: "error" });
      }).finally(()=>{
        setIsLoading(false)
      });
  };
  const handleUpdateVendor = (data) => {
    setIsLoading(true)
    dispatch(fetchAsyncUpdateVendor({ id: editData?._id, data: data }))
      .then((res) => {
        if (res?.payload) {
          addToast(orgJson.success.updatedVendor, { appearance: "success"});
          closeModal();
        }
      })
      .catch((err) => {
        addToast(orgJson.error.generic, { appearance: "error" });
      }).finally(()=>{
        setIsLoading(false)

      })
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      const filteredGsts = gstFields.filter(gst => gst.gstNo.trim() !== "");

      const updatedFormData = {
        ...formData,
        isVendor,
        isConsultant,
        customerType,
        taxPreference,
        billingAddress: address?.billingAddress,
        shippingAddress: address?.shippingAddress,
        gsts:filteredGsts

      };
      if (!isEdit) {
        handleAddVendor(updatedFormData);
      } else {
        handleUpdateVendor(updatedFormData);
      }
    }
  };

  const closeModelForm = () => {
    ConfirmationDialog({
      title: commonJson.close.confirm,
      text: commonJson.text.lost,
      icon: "warning",
      confirmButtonText: "Close",
      cancelButtonText: "Cancel",
      onConfirm: () => {
        closeModal();
      },
    });
  };

  const addBankDetail = () => {
    setFormData((prev) => ({
      ...prev,
      bankDetails: [
        ...prev.bankDetails,
        {
          hol:"",
          bnk: "",
          bch: "",
          ifc: "",
          swt: "",
          acNo: "",
          typ: 0,
          bAd: {
            ct: "",
            st: "",
          },
        },
      ],
    }));
  };
  const fillEditData = (item)=>{
    const vendor = item?.isV;
      const consultant = item?.isC;
      setIsVendor(vendor);
      setIsConsultant(consultant);
      if (item?.typ) {
        setCustomerType(item?.typ);
      }
      if (item?.txPrf) {
        setTaxPreference(item?.txPrf);
      }
    const sal = salutation.find((opt)=>opt.id === item?.sl)
    const gstTrt = GstTreatment.find((gst)=>gst.id === item?.gstTrt)
    const pos = indiaStateOptions.find((opt)=>opt.id === item?.pos)
   
    if (item) {
      const existData = {
        companyName: item?.name,
        salutation: sal || {},
        contactPerson: item?.cptn,
        email: item.mail,
        phone: item.ph,
        ledline: item.ld,
        gstTreatment: gstTrt || {},
        panNo: item?.pnNo,
        openingBal: item?.opBl,
        bankDetails: item?.bnkDtl || []
      };

      setFormData(existData);
       if (editData?.blAd) {
        const billAdd = {
          attention:editData?.blAd?.atn,   
          street1: editData?.blAd?.s1,
          street2: editData?.blAd.s2,
          country: {}, 
          state: {}, 
          city: {}, 
          pinCode: editData?.blAd.pin, 
          phone: editData?.blAd.ph, 
          email: editData?.blAd.mail
        }
        if(editData?.blAd?.ctr){
          GetCountries().then((result) => {
            billAdd.country = result?.find((opt)=> opt.id === editData?.blAd?.ctr) || {};
            if(billAdd.country && billAdd?.country?.id){
              GetState(billAdd.country.id).then((result) => {
                billAdd.state = result?.find((opt)=> opt.id === editData?.blAd?.st) || {};
                if(billAdd.state && billAdd?.state?.id){
                  GetCity(billAdd.country.id,billAdd.state.id).then((result) => {
                    billAdd.city = result?.find((opt)=> opt.id === editData?.blAd?.ct) || {};
                  });
                }
              });
            }
          });
        }
        setAddress((prev) => ({
          ...prev,
          billingAddress: billAdd
        }));
      }
      if (editData?.spAd) {
        const sppAdd = {
          attention:editData?.spAd?.atn,   
          street1: editData?.spAd?.s1,
          street2: editData?.spAd.s2,
          country: {}, 
          state: {}, 
          city: {}, 
          pinCode: editData?.spAd.pin, 
          phone: editData?.spAd.ph, 
          email: editData?.spAd.mail
        }
        if(editData?.spAd?.ctr){
          GetCountries().then((result) => {
            sppAdd.country = result?.find((opt)=> opt.id === editData?.spAd?.ctr) || {};
            if(sppAdd.country && sppAdd?.country?.id){
              GetState(sppAdd.country.id).then((result) => {
                sppAdd.state = result?.find((opt)=> opt.id === editData?.spAd?.st) || {};
                if(sppAdd.state && sppAdd?.state?.id){
                  GetCity(sppAdd.country.id,sppAdd.state.id).then((result) => {
                    sppAdd.city = result?.find((opt)=> opt.id === editData?.spAd?.ct) || {};
                  });
                }
              });
            }
          });
        }
        setAddress((prev) => ({
          ...prev,
          shippingAddress: sppAdd
        }));
      }
      if (editData?.gsts && editData?.gsts?.length) {
        setGstFields(editData?.gsts);
      }
    }
  }

  useEffect(() => {
    if (editData) {
      fillEditData(editData);
    }
  }, [editData]);

  const removeBankDetail = (index) => {
    if (isEdit) {
      ConfirmationDialog({
        title: orgJson.confirm.delete,
        text: orgJson.text.undone,
        icon: "warning",
        confirmButtonText: "Delete",
        cancelButtonText: "Cancel",
        onConfirm: () => {
          dispatch(fetchAsyncDeleteVendorBank(editData?._id, index)).then(
            (res) => {
              if (res?.payload) {
                addToast(orgJson.success.deletedBank, {
                  appearance: "success",
                });
                setFormData((prev) => ({
                  ...prev,
                  bankDetails: prev.bankDetails.filter(
                    (bankDetail, i) => i !== index
                  ),
                }));
              }
            }
          );
        },
      });
    } else {
      setFormData((prev) => ({
        ...prev,
        bankDetails: prev.bankDetails.filter((bankDetail, i) => i !== index),
      }));
    }
  };
  const handleSelectTab = (k) => {
    setActiveTab(k);
  };
  
  const checkGstNumberIsUnique = async (data) => {
    try {
      const res = await dispatch(fetchAsyncCheckGstIsUnique(data));
      return res?.payload?.unique ?? false; 
    } catch (err) {
      addToast(orgJson.error.generic, { appearance: "error" });
      return false; 
    }
  };
  const handleGstChange = async(index, value) => {
    const newGstFields = [...gstFields]; 
    const formattedValue = value.toUpperCase();
    if (formattedValue.length > MAX_GST_LENGTH) {
      return;
    }
    let state = {};
    if (GST_REGEX.test(formattedValue)) {
      const isDuplicate = newGstFields.some((field, idx) => field.gstNo === formattedValue && idx !== index);
      if (isDuplicate) {
        addToast("GST Number already exists!", {
          appearance: "error",
        });
        return;
      }
      const data = {
        gstNo: formattedValue,
        vendorId: editData?._id || null, 
      };
      // Check if the GST number is unique
      const isUnique = await checkGstNumberIsUnique(data);
      if (!isUnique) {
        addToast("This GST number is already registered.!", { appearance: "error" });
        return;
      }

      const extractedPan = formattedValue.substring(2, 12);
      const stateCode = formattedValue.substring(0, 2);
      state = findStateByGstCode(stateCode) || "";

      setFormData((prev) => ({
        ...prev,
        panNo: extractedPan
      }));
     
    }
    if (!formattedValue || GST_REGEX.test(formattedValue)) {
      setErrors((prev) => ({ ...prev, [`gstFields.${index}.gstNo`]: "" }));
    } else {
      setErrors((prev) => ({
        ...prev,
        [`gstFields.${index}.gstNo`]: "GST Number format is invalid.",
      }));
    }
    const isState = newGstFields.some((field, idx) => field.placeOfSupply === state.value && idx !== index);

    if (isState) {
      state = {}
    }
    newGstFields[index] = {
      gstNo:formattedValue,
      pos:state?.value
    }; 
    setGstFields(newGstFields);
  };

  const handlePosChange = (index, value) => {
    const isDuplicate = gstFields.some((field, idx) => field.pos === value && idx !== index);
    if (isDuplicate) {
      const newGstFields = gstFields.map((gstField, i) => {
        if (i === index) {
          return {
            ...gstField,
            pos:  "", 
          };
        }
        return gstField; 
      });
      addToast("Place Of Supply already exists!", {
        appearance: "error",
      });
    
      setGstFields(newGstFields);
    }
    else{

      const newGstFields = gstFields.map((gstField, i) => {
        if (i === index) {
          return {
            ...gstField,
            pos: value || "", 
          };
        }
        return gstField; 
      });
    
      setGstFields(newGstFields);
    }
  };

  useEffect(()=>{
    if(formData?.gstTreatment && ['Unregistered Business','Consumer'].includes(formData?.gstTreatment?.value)){
      setGstFields([{
        gstNo:"",
        pos:""
      }])
    }
  },[formData.gstTreatment]);
  
  const addGstField = () => {
    setGstFields([...gstFields, {
      gstNo:"",
      pos:""
    }]);
  };

  const findStateByName = useCallback((stateName) => {
    return indiaStateOptions.find(state => state.label === stateName);
  }, []);
  // Function to remove a GST field
  const removeGstField = (index) => {
    const newGstFields = gstFields.filter((_, i) => i !== index);
    setGstFields(newGstFields);
  };

  return (
    <>
      <Modal
        finalFocusRef={finalRef}
        isOpen={openModal}
        onClose={closeModelForm}
        size="xl"
      >
        <ModalOverlay />
        <ModalContent
          top="0" // Position it at the top
          margin="0 auto" // Center it horizontally
          bottom="0"
          className="add-form-modal-content"
        >
          <div className="fixed-header">
            <ModalHeader className="expense-modal-header">
              {isEdit ? "Edit" : "Add"} Vendor Details
            </ModalHeader>
            <ModalCloseButton />
          </div>
          {isLoading ? (
            <SpinnerLoader />
          ) : (
            <ModalBody>
              <Form onSubmit={handleSubmit} className="addForm">
                <div className="form-card">
                  <h5>Personal Details</h5>
                  <Row className="">
                    <Col>
                      <Box display="flex">
                        <Form.Label>Customer Type</Form.Label>
                        <Box className="d-flex mx-5">
                          <RadioField
                            name="individual"
                            isChecked={customerType === "individual"}
                            handleChange={(e) => setCustomerType(e.target.name)}
                            label="Individual"
                            customClass="mx-4"
                          />
                          <RadioField
                            name="business"
                            isChecked={customerType === "business"}
                            handleChange={(e) => setCustomerType(e.target.name)}
                            label="Business"
                            customClass="mx-4"
                          />
                        </Box>
                      </Box>
                    </Col>
                  </Row>
                  <Row className="">
                    <Col>
                      <Box display="flex">
                        <Form.Label>Type Of Vendor</Form.Label>
                        <Box className="d-flex mx-5">
                          <CheckboxField
                            name="isVendor"
                            label="Vendor"
                            customClass="vendor-add-checkbox mx-4"
                            isChecked={isVendor}
                            handleChange={(e) =>
                              setIsVendor(e.target.checked)
                            }
                          />
                          <CheckboxField
                            name="isConsultant"
                            label="Consultant"
                            customClass="vendor-add-checkbox mx-4"
                            isChecked={isConsultant}
                            handleChange={(e) =>
                              setIsConsultant(e.target.checked)
                            }
                          />
                        </Box>
                      </Box>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Box display="flex" className="input-box">
                        <Form.Label>
                          Company Name <span className="span-star">*</span>
                        </Form.Label>
                        <InputFormControl
                          name="companyName"
                          placeholder="Company Name"
                          value={formData.companyName}
                          handleChange={(e) => handleChange(e)}
                          isInvalid={
                            !formData.companyName && !!errors.companyName
                          }
                        />
                      </Box>
                      <p className="form_error">
                        {" "}
                        {!formData.companyName && errors.companyName}
                      </p>
                    </Col>
                    <Col></Col>
                  </Row>

                  <Row>
                    <Col>
                      <Box display="flex" className="input-box contact-box">
                        <Form.Label style={{ width: "150px" }}>
                          Primary Contact <span className="span-star">*</span>
                        </Form.Label>
                        <Box display="flex" justifyContent="space-around">
                          <select
                            placeholder="salutation"
                            className="salu-select mx-3"
                            name="salutation"
                            value={formData?.salutation?.value}
                            onChange={(e) => {
                              const selectSal = salutation.find(
                                (item) => item?.value === e?.target?.value
                              );
                              setFormData({
                                ...formData,
                                salutation: selectSal,
                              });
                            }}
                          >
                            {salutation.map((item, index) => (
                              <option key={index} value={item.value}>
                                {item.label}
                              </option>
                            ))}
                          </select>
                          <InputFormControl
                            name="contactPerson"
                            placeholder="Name"
                            value={formData.contactPerson}
                            handleChange={(e) => handleChange(e)}
                            isInvalid={
                              !formData.contactPerson && !!errors.contactPerson
                            }
                          />
                        </Box>
                      </Box>
                      <p className="form_error">
                        {!formData.contactPerson && errors.contactPerson}
                      </p>
                    </Col>
                    <Col></Col>
                  </Row>
                  <Row className="">
                    <Col>
                      <Box display="flex" className="input-box">
                        <Form.Label>Email</Form.Label>
                        <InputFormControl
                          customClass="mb-2"
                          name="email"
                          value={formData?.email || ""}
                          handleChange={(e) => handleChange(e)}
                          groupText1={
                            <InputGroup.Text id="basic-addon1">
                              <CiMail />
                            </InputGroup.Text>
                          }
                        />
                      </Box>

                      <p className="form_error">{errors?.email}</p>
                    </Col>
                    <Col></Col>
                  </Row>
                  <Row className="mt-0">
                    <Col>
                      <Box display="flex" className="input-box" width={665}>
                        <Form.Label>Phone</Form.Label>
                        <Box display="flex" justifyContent="space-between">
                          <Box>
                            <InputFormControl
                              name="ledline"
                              placeholder="Work Phone"
                              value={formData?.ledline || ""}
                              handleChange={(e) => handleChange(e)}
                              groupText1={
                                <InputGroup.Text id="basic-addon1">
                                  <BsTelephone />
                                </InputGroup.Text>
                              }
                            />
                            <p className="form_error">{errors?.ledline}</p>
                          </Box>
                          <Box className="mx-2">
                            <InputFormControl
                              name="phone"
                              placeholder="Mobile"
                              value={formData?.phone || ""}
                              handleChange={(e) => handleChange(e)}
                              isInvalid={!!errors.phone}
                              groupText1={
                                <InputGroup.Text id="basic-addon1">
                                  <MdOutlinePhoneAndroid />
                                </InputGroup.Text>
                              }
                            />
                            <p className="form_error">{errors?.phone}</p>
                          </Box>
                        </Box>
                      </Box>
                    </Col>
                  </Row>
                </div>

                <div>
                  <Tabs
                    // defaultActiveKey="otherDetails"
                    defaultActiveKey={activeTab ? activeTab : "otherDetails"}
                    transition={false}
                    id="noanim-tab-example"
                    className="add-form-tabs"
                    onSelect={handleSelectTab}
                  >
                    <Tab
                      eventKey="otherDetails"
                      title="Other Details"
                      className="add-form-tab mx-0"
                    >
                      <div>
                        <Row>
                          <Col>
                            <Box display="flex" className="input-box">
                              <Form.Label>
                                GST Treatment{" "}
                                <span className="span-star">*</span>
                              </Form.Label>
                              <VendorCustomSelect
                                options={GstTreatment}
                                placeHolder=""
                                onChange={(newValue) => {
                                  setFormData({
                                    ...formData,
                                    gstTreatment: newValue,
                                  });
                                }}
                                isSearchable
                                isInvalid={
                                  !formData?.gstTreatment &&
                                  !!errors.gstTreatment
                                }
                                defaultValue={formData?.gstTreatment}
                              />
                            </Box>
                            {!formData?.gstTreatment && (
                              <p className="form_error">
                                {errors?.gstTreatment}
                              </p>
                            )}
                          </Col>
                          <Col></Col>
                        </Row>
                        {formData?.gstTreatment &&
                          !["Unregistered Business", "Consumer"].includes(
                            formData?.gstTreatment?.value
                          ) && (
                            <Row>
                              <Col>
                                <Box display="flex" className="input-box">
                                  <Row>
                                    <Col>
                                      <Form.Label>
                                        GSTIN / UIN{" "}
                                        <span className="span-star">*</span>
                                        <Button
                                          className="add-vendor-gst"
                                          onClick={(e) => addGstField()}
                                        >
                                          +
                                        </Button>
                                      </Form.Label>
                                    </Col>
                                    <Col>
                                      <Box className="multiple-gst-field">
                                        {gstFields.map((gst, index) => {
                                          const defaultValue = gst?.pos
                                            ? findStateByName(gst.pos)
                                            : null;
                                          return (
                                            <div className="gst-fields-div">
                                              <InputFormControl
                                                name="gstFields"
                                                placeholder="GST Number"
                                                value={gst?.gstNo || ""}
                                                handleChange={(e) =>
                                                  handleGstChange(
                                                    index,
                                                    e.target.value
                                                  )
                                                }
                                                isInvalid={
                                                  !!errors[
                                                    `gstFields.${index}.gstNo`
                                                  ]
                                                }
                                              />

                                              <VendorCustomSelect
                                                options={indiaStateOptions}
                                                placeHolder="Place Of Supply"
                                                onChange={(newValue) =>
                                                  handlePosChange(
                                                    index,
                                                    newValue?.value
                                                  )
                                                }
                                                isSearchable
                                                isDisabled={!gst?.gstNo}
                                                defaultValue={
                                                  defaultValue || ""
                                                }
                                              />
                                              <button
                                                disabled={index === 0}
                                                className="gst-remove-btn"
                                                onClick={(e) =>
                                                  removeGstField(index)
                                                }
                                              >
                                                X
                                              </button>
                                            </div>
                                          );
                                        })}

                                        <p className="form_error mx-1">
                                          {errors?.gstNo}
                                        </p>
                                      </Box>
                                    </Col>
                                  </Row>
                                </Box>
                              </Col>
                            </Row>
                          )}
                        <Row>
                          <Col>
                            <Box display="flex" className="input-box">
                              <Form.Label>PAN</Form.Label>
                              <Box display="flex">
                                <InputFormControl
                                  name="panNo"
                                  placeholder="PAN Number"
                                  value={formData.panNo}
                                  handleChange={(e) => handleChange(e)}
                                  isInvalid={!!errors.panNo}
                                />
                                <div className="mt-1">
                                  <CustomPopover
                                    className="mx-"
                                    popoverText="Please note that you can change the PAN number according to any one GST number. Ensure that the PAN number is correct."
                                  />
                                </div>
                              </Box>
                            </Box>
                            <p className="form_error">{errors?.panNo}</p>
                          </Col>
                          <Col></Col>
                        </Row>
                        <Row className="">
                          <Col>
                            <Box display="flex">
                              <Form.Label>
                                Tax Preference{" "}
                                <span className="span-star">*</span>
                              </Form.Label>
                              <Box className="d-flex mx-5">
                                <RadioField
                                  name="taxable"
                                  value="taxable"
                                  isChecked={taxPreference === "taxable"}
                                  handleChange={(e) =>
                                    setTaxPreference(e.target.value)
                                  }
                                  label="Taxable"
                                  customClass="mx-2"
                                />
                                <RadioField
                                  name="taxExempt"
                                  value="taxExempt"
                                  isChecked={taxPreference === "taxExempt"}
                                  handleChange={(e) =>
                                    setTaxPreference(e.target.value)
                                  }
                                  label="Tax Exempt"
                                  customClass="mx-3"
                                />

                              </Box>
                            </Box>
                            {!taxPreference && (
                              <p className="form_error">
                                {errors?.taxPreference}
                              </p>
                            )}
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <Box display="flex" className="input-box">
                              <Form.Label>Opening Balance</Form.Label>

                              <AmountInputField
                                value={formData?.openingBal}
                                placeholder="0.00"
                                name="openingBal"
                                handleChange={(value) => {
                                  handleChange({
                                    target: {
                                      name: "openingBal",
                                      value: value,
                                    },
                                  });
                                }}
                              />
                            </Box>
                          </Col>
                          <Col></Col>
                        </Row>
                      </div>
                    </Tab>
                    <Tab
                      eventKey="address"
                      title="Address"
                      className="add-form-tab mx-0"
                    >
                      <BillAndShipAddressForm
                        handleAddress={(e, type) =>
                          handleAddressChange(e, type)
                        }
                        addressData={address}
                        copyShippingAdd={(obj) => copyShippingAddress(obj)}
                        errors={errors}
                      />
                    </Tab>
                    <Tab
                      eventKey="bank"
                      title="Bank Details"
                      className="add-form-tab mx-0"
                    >
                      {formData?.bankDetails &&
                        formData?.bankDetails?.length > 0 &&
                        formData?.bankDetails.map((bankDetail, index) => (
                          <BankForm
                            bankDetail={bankDetail}
                            index={index}
                            removeBankDetail={removeBankDetail}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            errors={errors}
                            companyName={formData?.companyName}
                          />
                        ))}
                      <div className="form-card mt-4">
                        <Box
                          display="flex"
                          alignItems="center"
                          onClick={addBankDetail}
                        >
                          <h5>Add Bank</h5>

                          <Button className="add-project mt-2">
                            <FaPlusCircle
                              className="add-project-icon"
                              size={15}
                            />
                          </Button>
                        </Box>
                      </div>
                    </Tab>
                  </Tabs>
                </div>

                <ModalFooter className="mt-4">
                  <Button
                    type="submit"
                    className="submit-btn"
                    variant="brand"
                    style={{ background: "#191063" }}
                  >
                    Submit
                  </Button>
                </ModalFooter>
              </Form>
            </ModalBody>
          )}
        </ModalContent>
      </Modal>
    </>
  );
};

export default VendorsAddNew;
